import React from 'react';
import cls from 'classnames';

import { Balloons } from './balloons';
import { Shards } from './shards';

import styles from './Confetti.module.scss';

interface ConfettiProps {
  explode?: boolean;
  confettiCount?: number;
  balloonCount?: number;
  children: React.ReactNode | string;
  showConfetti: boolean;
  className?: string;
}

export default function Confetti({
  explode,
  confettiCount,
  balloonCount = 5,
  children,
  showConfetti,
  className,
}: ConfettiProps) {
  const wrapperCls = React.useMemo(() => cls({ ['relative z-10']: explode }), [explode]);
  const shardCount = React.useMemo(
    () => (confettiCount ? confettiCount : explode ? 25 : 100),
    [confettiCount, explode],
  );

  return (
    <div className={`${styles.confettiContainer} ${className}`}>
      <div className={wrapperCls}>{children}</div>

      {showConfetti && (
        <div className={styles.confetti}>
          {!explode && <Balloons count={balloonCount} />}

          <Shards explode={explode} count={shardCount} />
        </div>
      )}
    </div>
  );
}
